// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   HOME PAGE COMPONENT STYLES
   ============================================ */

/* Page heading */
#homePageText {
	color: #27405f;
	font-weight: 600;
	margin-bottom: 1rem;
}

/* Market dropdown container */
.ui-inputgroup {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 0.5rem;
}

/* First heading style */
h5.first {
	display: flex;
	align-items: center;
	color: #495057;
	font-weight: 600;
	margin: 0;
}

/* Dashboard link */
.ui-inputgroup a {
	color: #27405f;
	text-decoration: none;
}

.ui-inputgroup a:hover {
	color: #1d3049;
	text-decoration: underline;
}

/* Dashboard link with underline */
.dashboard-link {
	color: #27405f !important;
	text-decoration: underline !important;
	cursor: pointer;
}

.dashboard-link:hover {
	color: #1d3049 !important;
}

/* Message display section */
.messageShow h1 {
	color: #27405f;
}

/* Error/unauthorized message */
.errorAuthId {
	padding: 1rem;
	background: #f8d7da;
	border: 1px solid #f5c6cb;
	border-radius: 4px;
	color: #721c24;
	margin: 1rem 0;
}

/* ============================================
   PRIMENG 19 SELECT/DROPDOWN OVERRIDES
   ============================================ */
:host ::ng-deep p-dropdown,
:host ::ng-deep p-select,
:host ::ng-deep .p-dropdown,
:host ::ng-deep .p-select {
	display: inline-flex !important;
	min-width: 120px !important;
	max-width: 140px !important;
	background: #ffffff !important;
	border: 1px solid #ced4da !important;
	border-radius: 4px !important;
}

:host ::ng-deep .p-dropdown:hover,
:host ::ng-deep .p-select:hover {
	border-color: #27405f !important;
}

:host ::ng-deep .p-dropdown-label,
:host ::ng-deep .p-select-label {
	padding: 0.5rem 0.75rem !important;
	color: #495057 !important;
	font-size: 0.9rem !important;
}

:host ::ng-deep .p-dropdown-trigger,
:host ::ng-deep .p-select-dropdown {
	width: 2.5rem !important;
	color: #6c757d !important;
	background: transparent !important;
}

:host ::ng-deep .p-dropdown-panel,
:host ::ng-deep .p-select-overlay {
	background: #ffffff !important;
	border: 1px solid #dee2e6 !important;
	border-radius: 4px !important;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important;
}

:host ::ng-deep .p-dropdown-item,
:host ::ng-deep .p-select-option {
	padding: 0.5rem 1rem !important;
	color: #495057 !important;
}

:host ::ng-deep .p-dropdown-item:hover,
:host ::ng-deep .p-select-option:hover {
	background: #e9ecef !important;
}

:host ::ng-deep .p-dropdown-item.p-highlight,
:host ::ng-deep .p-select-option-selected {
	background: #27405f !important;
	color: #ffffff !important;
}`, "",{"version":3,"sources":["webpack://./src/app/home-page/home-page.component.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD,iBAAiB;AACjB;CACC,cAAc;CACd,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA,8BAA8B;AAC9B;CACC,aAAa;CACb,mBAAmB;CACnB,eAAe;CACf,WAAW;AACZ;;AAEA,wBAAwB;AACxB;CACC,aAAa;CACb,mBAAmB;CACnB,cAAc;CACd,gBAAgB;CAChB,SAAS;AACV;;AAEA,mBAAmB;AACnB;CACC,cAAc;CACd,qBAAqB;AACtB;;AAEA;CACC,cAAc;CACd,0BAA0B;AAC3B;;AAEA,kCAAkC;AAClC;CACC,yBAAyB;CACzB,qCAAqC;CACrC,eAAe;AAChB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA,4BAA4B;AAC5B;CACC,cAAc;AACf;;AAEA,+BAA+B;AAC/B;CACC,aAAa;CACb,mBAAmB;CACnB,yBAAyB;CACzB,kBAAkB;CAClB,cAAc;CACd,cAAc;AACf;;AAEA;;iDAEiD;AACjD;;;;CAIC,+BAA+B;CAC/B,2BAA2B;CAC3B,2BAA2B;CAC3B,8BAA8B;CAC9B,oCAAoC;CACpC,6BAA6B;AAC9B;;AAEA;;CAEC,gCAAgC;AACjC;;AAEA;;CAEC,kCAAkC;CAClC,yBAAyB;CACzB,4BAA4B;AAC7B;;AAEA;;CAEC,wBAAwB;CACxB,yBAAyB;CACzB,kCAAkC;AACnC;;AAEA;;CAEC,8BAA8B;CAC9B,oCAAoC;CACpC,6BAA6B;CAC7B,sDAAsD;AACvD;;AAEA;;CAEC,+BAA+B;CAC/B,yBAAyB;AAC1B;;AAEA;;CAEC,8BAA8B;AAC/B;;AAEA;;CAEC,8BAA8B;CAC9B,yBAAyB;AAC1B","sourcesContent":["/* ============================================\n   HOME PAGE COMPONENT STYLES\n   ============================================ */\n\n/* Page heading */\n#homePageText {\n\tcolor: #27405f;\n\tfont-weight: 600;\n\tmargin-bottom: 1rem;\n}\n\n/* Market dropdown container */\n.ui-inputgroup {\n\tdisplay: flex;\n\talign-items: center;\n\tflex-wrap: wrap;\n\tgap: 0.5rem;\n}\n\n/* First heading style */\nh5.first {\n\tdisplay: flex;\n\talign-items: center;\n\tcolor: #495057;\n\tfont-weight: 600;\n\tmargin: 0;\n}\n\n/* Dashboard link */\n.ui-inputgroup a {\n\tcolor: #27405f;\n\ttext-decoration: none;\n}\n\n.ui-inputgroup a:hover {\n\tcolor: #1d3049;\n\ttext-decoration: underline;\n}\n\n/* Dashboard link with underline */\n.dashboard-link {\n\tcolor: #27405f !important;\n\ttext-decoration: underline !important;\n\tcursor: pointer;\n}\n\n.dashboard-link:hover {\n\tcolor: #1d3049 !important;\n}\n\n/* Message display section */\n.messageShow h1 {\n\tcolor: #27405f;\n}\n\n/* Error/unauthorized message */\n.errorAuthId {\n\tpadding: 1rem;\n\tbackground: #f8d7da;\n\tborder: 1px solid #f5c6cb;\n\tborder-radius: 4px;\n\tcolor: #721c24;\n\tmargin: 1rem 0;\n}\n\n/* ============================================\n   PRIMENG 19 SELECT/DROPDOWN OVERRIDES\n   ============================================ */\n:host ::ng-deep p-dropdown,\n:host ::ng-deep p-select,\n:host ::ng-deep .p-dropdown,\n:host ::ng-deep .p-select {\n\tdisplay: inline-flex !important;\n\tmin-width: 120px !important;\n\tmax-width: 140px !important;\n\tbackground: #ffffff !important;\n\tborder: 1px solid #ced4da !important;\n\tborder-radius: 4px !important;\n}\n\n:host ::ng-deep .p-dropdown:hover,\n:host ::ng-deep .p-select:hover {\n\tborder-color: #27405f !important;\n}\n\n:host ::ng-deep .p-dropdown-label,\n:host ::ng-deep .p-select-label {\n\tpadding: 0.5rem 0.75rem !important;\n\tcolor: #495057 !important;\n\tfont-size: 0.9rem !important;\n}\n\n:host ::ng-deep .p-dropdown-trigger,\n:host ::ng-deep .p-select-dropdown {\n\twidth: 2.5rem !important;\n\tcolor: #6c757d !important;\n\tbackground: transparent !important;\n}\n\n:host ::ng-deep .p-dropdown-panel,\n:host ::ng-deep .p-select-overlay {\n\tbackground: #ffffff !important;\n\tborder: 1px solid #dee2e6 !important;\n\tborder-radius: 4px !important;\n\tbox-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important;\n}\n\n:host ::ng-deep .p-dropdown-item,\n:host ::ng-deep .p-select-option {\n\tpadding: 0.5rem 1rem !important;\n\tcolor: #495057 !important;\n}\n\n:host ::ng-deep .p-dropdown-item:hover,\n:host ::ng-deep .p-select-option:hover {\n\tbackground: #e9ecef !important;\n}\n\n:host ::ng-deep .p-dropdown-item.p-highlight,\n:host ::ng-deep .p-select-option-selected {\n\tbackground: #27405f !important;\n\tcolor: #ffffff !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
